export default {
  data() {
    return {
      currentEvents: [],
      eventsLoading: false,
      popupTitle: "",
    };
  },
  methods: {
    getAllCasts(boardId) {
      this.eventsLoading = true;
      this.popupTitle = "Casts";
      this.isEventsPopup = true;
      this.currentEvents = [];
      this.$store
        .dispatch("boards/fetchAllBoardUsers", boardId)
        .then((res) => {
          if (res.data) {
            let promises = [];
            for (let i = 0; i < res.data.length; i++) {
              promises.push(
                this.$store
                  .dispatch("videowiki/fetchCasts", {
                    boardId: boardId,
                    email: res.data[i].userData.email,
                  })
                  .then((res) => {
                    if (res.my_events) {
                      this.currentEvents.push(...res.my_events);
                    }
                  })
                  .catch((err) => {
                    throw err;
                  })
              );
            }
            Promise.all(promises)
              .then(() => {
                this.eventsLoading = false;
              })
              .catch((err) => {
                console.error(err);
                this.eventsLoading = false;
              });
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    getAllRooms(boardId) {
      this.eventsLoading = true;
      this.popupTitle = "Rooms";
      this.isEventsPopup = true;
      this.currentEvents = [];
      this.$store
        .dispatch("boards/fetchAllBoardUsers", boardId)
        .then((res) => {
          if (res.data) {
            let promises = [];
            for (let i = 0; i < res.data.length; i++) {
              promises.push(
                this.$store
                  .dispatch("videowiki/fetchRooms", {
                    boardId: boardId,
                    email: res.data[i].userData.email,
                  })
                  .then((res) => {
                    if (res.my_events) {
                      this.currentEvents.push(...res.my_events);
                    }
                  })
                  .catch((err) => {
                    throw err;
                  })
              );
            }
            Promise.all(promises)
              .then(() => {
                this.eventsLoading = false;
              })
              .catch((err) => {
                console.error(err);
                this.eventsLoading = false;
              });
          }
        })
        .catch((err) => {
          throw err;
        });
    },
    formatTimestamp(timestamp) {
      const [hours, minutes, ...seconds] = timestamp.split(/:|\./).map(Number);
      return `${hours}:${minutes}:${seconds[0] || 0}`;
    },
  },
};
